export default __webpack_public_path__ + "assets/img/1Le5VoO.png";